// ===== 1. Comprobaciones de permisos =====

// --- Puede aprobar una PO ---
export const canApprove = (po, role, dept) => {
  if (!po || ["Cerrada", "Anulada"].includes(po.status)) return false;
  const { requiresHod, hod, pm, controller } = po.approvals || {};

  if (role === "HOD" && po.department === dept) return !hod?.approved;
  if (role === "PM") {
    if (requiresHod && !hod?.approved) return false;
    return !pm?.approved;
  }
  if (role === "Controller") {
    if (!pm?.approved) return false;
    return !controller?.approved;
  }
  return false;
};

// --- Puede retirar su aprobación ---
export const canUnapprove = (po, role, dept) => {
  const { hod, pm, controller } = po.approvals || {};
  if (role === "HOD" && po.department === dept) return !!hod?.approved;
  if (role === "PM") return !!pm?.approved && !controller?.approved;
  if (role === "Controller") return !!controller?.approved;
  return false;
};

// --- Puede gestionar estados (cerrar, anular, reabrir) ---
export const canManageStatus = (role) =>
  ["PM", "Controller", "superadmin"].includes(role);

// --- Puede editar facturas (PM o Controller) ---
export const canCompleteInvoice = (role) => canManageStatus(role);
